import { takeLatest, put, call } from 'redux-saga/effects';
import {
    FETCH_BENCHMARK_CALCULATION_PARAMETER_REQUEST, fetchBenchmarkCalculationParameterResponse, FETCH_CALCULATE_BENCHMARK_REQUEST,
    fetchCalculateBenchmarkResponse
} from './action';
import { REPORT } from '../../../../../config';
import { HTTP_HEADERS } from '../../../../../constants'
import request from "../../../../../components/Utils/httpHelper";

export function* fetchBenchmarkCalculationParameterRequest(action) {
    let requestURL = `${REPORT}/benchmark/getniccode/${action.data.caseId}`;
    try {
        const data = yield call(request, requestURL, { method: 'GET', headers: HTTP_HEADERS });
        yield put(fetchBenchmarkCalculationParameterResponse({ data: data.data, status: "SUCCESS" }))
    }
    catch (err) {
        yield put(fetchBenchmarkCalculationParameterResponse({ ...err.response, status: "FAILURE" }))
    }
}

export function* fetchBenchmarkCalculationParameterData() {
    yield takeLatest(FETCH_BENCHMARK_CALCULATION_PARAMETER_REQUEST, fetchBenchmarkCalculationParameterRequest);
}

export function* fetchCalculateBenchmarkRequest(action) {
    let requestURL = `${REPORT}/benchmark/calculatebenchmark/${action.data.caseId}`;
    try {
        const data = yield call(request, requestURL, { data: action.data.formData, method: 'POST', headers: HTTP_HEADERS });
        yield put(fetchCalculateBenchmarkResponse({ data: data.data, status: "SUCCESS" }))
    }
    catch (err) {
        yield put(fetchCalculateBenchmarkResponse({ ...err.response, status: "FAILURE" }))
    }
}

export function* fetchCalculateBenchmarkData() {
    yield takeLatest(FETCH_CALCULATE_BENCHMARK_REQUEST, fetchCalculateBenchmarkRequest);
}